import { createContext, useContext } from 'react';

export const IntegrationsContext = createContext();

export const useIntegrationsContext = () => useContext(IntegrationsContext);
